import React from 'react';
import OutsourceChart from '../../../outsource/components/OutsourceChart';
import { ActiveBadge } from '../../../shared/components/ActiveLabel';
import LinkButton from '../../../shared/components/LinkButton';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import './OutsourceListGrid.css';

export default class OutsourceListGrid extends React.Component {

    render() {
        const {
            outsources,
        } = this.props;

        return (
            <div className="row component-outsource-list-grid" id="outsourcing">
                {_.map(outsources, (outsource, index) => this.renderOutsourcesAdmin(outsource, index))}
            </div>
        );
    }

    renderOutsourcesAdmin(outsource, index) {
        return (
            <div key={index} className={'col-type outsource-item-container'}>
                <div className={'view-type flex-card'}>
                    <div className="chart-wrap">
                        <OutsourceChart stats={outsource.document_stats}/>
                    </div>
                    <div className="flex-text">
                        <div className="sub-item">
                            <h3>{outsource.name}</h3>
                        </div>
                        <div className="sub-item">
                            <p className="m-b-0">{outsource.nif}</p>
                        </div>
                        <div className="responsables">
                            {this.renderAdmins(outsource)}
                        </div>
                        <div className="sub-item">
                            <ActiveBadge active={!outsource.disabled}/>
                        </div>
                        <div className="sub-item button-view">
                            <LinkButton
                                to={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, { id: outsource.id })}
                                text={I18nUtils.tr('TR_VER_FICHA')}
                                className={'btn-sm'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderAdmins(outsource) {
        if ( !outsource || !outsource.admins ) {
            return null;
        }
        const labels = [];
        const adminsTooltip = [];
        let adminsExtra = 0;

        outsource.admins.forEach((admin, index) => {
            if ( index <= 1 ) {
                labels.push(<span key={index}
                                  className="label bg-blue-grey">{admin.name} {admin.last_name}</span>);
            } else {
                if ( adminsTooltip.length > 0 ) {
                    adminsTooltip.push(<br key={index * 10}/>);
                }
                adminsTooltip.push(<span key={index}
                                         className="label bg-blue-grey">{admin.name} {admin.last_name}</span>);
                adminsExtra += 1;
            }
        });

        if ( adminsTooltip.length > 0 ) {
            const popover = (
                <Popover id="popover-positioned-right" title="">
                    {adminsTooltip.map(admin => admin)}
                </Popover>
            );
            labels.push(
                <OverlayTrigger span key={adminsTooltip.length + 1} trigger={['hover', 'focus']} placement="bottom"
                                overlay={popover}>
                    <span className="label bg-grey">{adminsExtra} más</span>
                </OverlayTrigger>,
            );
        }
        return labels;
    }
}

OutsourceListGrid.propTypes = {
    outsources: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/OutsourceListGrid.jsx